"use client;"
import React,{ useEffect } from 'react'
import NewNavbar from './pages/Component/NewNavbar'
import Footer from './pages/Component/Footer'
import {Route,Routes,useLocation} from 'react-router-dom'
import ReactGA from 'react-ga4';
import EverestHeliTour from './pages/Everest-Heli-Tour'
import Tripflyer from './pages/tripflyertravels&himalayastravels2'
import ScrollToTop from "./pages/Component/ScrollToTop"
import MHeliTour from './pages/mountain-flight-nepal-tour'
import  OneDayKathmanduTour from './pages/One-Day-Kathmandu-Tour'
import  Kathnight from './pages/tripflyertravels&himalayastravels'
import  OneD from './pages/one-day-nepal-7unescoheritage-tour'
import  KathmandupokharaTour from './pages/kathmandu-pokhara-6days-tours.js'
import  KathmanduchitwannagarkotTour from './pages/kathmandu-chitwan-nagarkot'
import  Lumbini from './pages/kathmandu-chitwan-lumbini'
import  Senioreve from './pages/everest-for-senior-withouttrek'
import  Nagarkot from './pages/kathmandu-nagarkot-4days-tour'
import  KathmandupokharachitwanTour from './pages/kathmandu-chitwan-pokhara-8days-nepaltour'
import  Okna from './pages/kathmandu-chitwan-pokhara-nagarkot-8days-tour'
import  Hobandipur from './pages/kathmandu-chitwan-pokhara-bandipur-nagarkot-9days-tour'
import  KachlupoTour from './pages/kathmandu-chitwan-lumbini-pokhara-8days-tour'
import Home from './pages/Home'
import NepalPackage from './pages/nepal-tour'
import Guidetable from './pages/guidetable'
import Chineseguide from './pages/chineseguide'
import Activity from './pages/activity'
import ContactUs from './pages/contactus'
import AboutUs from './pages/aboutus'
import Rental from './pages/rental'
import Whyd from './pages/whytravel'
import Whydq from './pages/b2b'
import Founder from "./pages/meetourfounder"
import LegalDocuments from "./pages/legal"
import Reviews from "./pages/reviews"
import Gallerys from "./pages/gallery"
import Blogs from "./pages/blogs"
import FAQS from "./pages/faqs"
import Nepalluxury from './pages/nepal-wellness-retreat-7days-tour'
import Hoteloi from "./pages/hotelo"
import Terms from './pages/Component/Terms'
import Whatsapp from './pages/Component/whatsapp'
import Buddhism from './pages/buddhism-tour-nepal'
import Allnepal from './pages/all-nepal-tour'
import Lumbinicv from './pages/kathmandu-chitwan-lumbini-pokhara-ghandrukh-dhampush-bandipur-nagarkot-10daystour'
import Pea from './pages/kathmandu-chitwan-pokhara-lumbini-bandipur-nagarkot-11days-tour'
import Sure from './pages/tripflyertravels&himalayastravels3'
import Suretwo from './pages/tripflyertravels&himalayastravels4'
const TRACKING_ID = " G-QMY8FTSE57";
const App = () => {
  const location = useLocation();

  // 1. INITIALIZATION: Fires only once when a user first lands on the site
  useEffect(() => {
    ReactGA.initialize(TRACKING_ID);
  }, []);

  // 2. AUTOMATIC TRACKING LOOP: Tracks every single page automatically!
  useEffect(() => {
    // This looks at the browser address bar every single time a route changes
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]); // <--- This triggers automatically whenever the path shifts
useEffect(() => {
    const handleGlobalClick = (event) => {
      // Find out if the clicked item is a button or a link containing booking terms
      const target = event.target;
      const buttonText = target.innerText ? target.innerText.toLowerCase() : "";
      
      if (
        target.tagName === 'BUTTON' || 
        target.tagName === 'A' ||
        buttonText.includes("Book Now") || 
        buttonText.includes("Enquiry Now") || 
        buttonText.includes("whatsapp")
      ) {
        // Automatically fetch the clean route path name as context data
        const currentTourPage = location.pathname; 

        // Send custom event parameters cleanly to GA4
        ReactGA.event({
          category: "Conversion Intent",
          action: "Clicked Booking Button",
          label: `Button: "${target.innerText}" on Page: ${currentTourPage}`,
        });
        
        console.log(`Tracked Event: Clicked "${target.innerText}" inside path: ${currentTourPage}`);
      }
    };

    // Attach listener to the entire DOM window
    window.addEventListener('click', handleGlobalClick);

    // Clean up the event listener if the component ever unmounts
    return () => {
      window.removeEventListener('click', handleGlobalClick);
    };
  }, [location]); // Re-runs layout binding on route context update
  return (
    <>
    <NewNavbar/>

      {/* Include it here, right at the top level of your router */}
      <ScrollToTop />   
<Routes>
<Route index element={<Home/>}/>
<Route path='/Home' element={<Home/>}/>
<Route path='/Everest-Heli-Tour'element={<EverestHeliTour/>}/>
<Route path='/kathmandu-chitwan-pokhara-8days-nepaltour'element={<KathmandupokharachitwanTour/>}/>
<Route path='/kathmandu-chitwan-pokhara-nagarkot-8days-tour'element={<Okna/>}/>
<Route path='/kathmandu-chitwan-pokhara-bandipur-nagarkot-9days-tour'element={<Hobandipur/>}/>
<Route path='/mountain-flight-nepal-tour'element={<MHeliTour/>}/>
<Route path='/One-Day-Kathmandu-Tour'element={<OneDayKathmanduTour/>}/>
<Route path='/one-day-nepal-7unescoheritage-tour'element={<OneD/>}/>
<Route path='/tripflyertravels&himalayastravels'element={<Kathnight/>}/>
<Route path='/tripflyertravels&himalayastravels2'element={<Tripflyer/>}/>
<Route path='/tripflyertravels&himalayastravels3'element={<Sure/>}/>
<Route path='/tripflyertravels&himalayastravels4'element={<Suretwo/>}/>
<Route path='/kathmandu-pokhara-6days-tours'element={<KathmandupokharaTour/>}/>
<Route path='/everest-for-senior-withouttrek'element={<Senioreve/>}/>
<Route path='/kathmandu-chitwan-nagarkot'element={<KathmanduchitwannagarkotTour/>}/>
<Route path='/kathmandu-chitwan-lumbini'element={<Lumbini/>}/>
<Route path='/kathmandu-nagarkot-4days-tour'element={<Nagarkot/>}/>
<Route path='/kathmandu-chitwan-lumbini-pokhara-8days-tour'element={<KachlupoTour/>}/>
<Route path='/nepal-tour'element={<NepalPackage/>}/>
<Route path='/guidetable'element={<Guidetable/>}/>
<Route path='/nepal-wellness-retreat-7days-tour'element={<Nepalluxury/>}/>
<Route path='/chineseguide'element={<Chineseguide/>}/>
<Route path='/activity'element={<Activity/>}/>
<Route path='/contactus'element={<ContactUs/>}/>
<Route path='/aboutus'element={<AboutUs/>}/>
<Route path='/rental'element={<Rental/>}/>
<Route path='/whytravel'element={<Whyd/>}/>
<Route path='/b2b'element={<Whydq/>}/>
<Route path='/meetourfounder'element={<Founder/>}/>
<Route path='/legal'element={<LegalDocuments/>}/>
<Route path='/reviews'element={<Reviews/>}/>
<Route path='/gallery'element={<Gallerys/>}/>
<Route path='/blogs'element={<Blogs/>}/>
<Route path='/faqs'element={<FAQS/>}/>
<Route path='/buddhism-tour-nepal'element={<Buddhism/>}/>
<Route path='/all-nepal-tour'element={<Allnepal/>}/>
<Route path='/Terms'element={<Terms/>}/>
<Route path='/kathmandu-chitwan-pokhara-lumbini-bandipur-nagarkot-11days-tour'element={<Pea/>}/>
<Route path='/kathmandu-chitwan-lumbini-pokhara-ghandrukh-dhampush-bandipur-nagarkot-10daystour'element={<Lumbinicv/>}/>
</Routes>

<Whatsapp/>
   <Footer/>
    </>
  )
}

export default App
